import Box from "@mui/material/Box";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { PaleteEnum } from "../interfaces/Enums";

interface CircularProgressWithLabelProps extends CircularProgressProps {
  value: number;
  isPercentage?: boolean;
  maxValue?: number;
  textSize?: number;
}

export function CircularProgressWithLabel({
  value,
  maxValue = 60,
  textSize = 12,
  isPercentage = false,
  ...props
}: CircularProgressWithLabelProps) {
  const percentage = (value / maxValue) * 100;

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        size={26}
        thickness={4}
        variant="determinate"
        value={percentage}
        sx={{ color: PaleteEnum.bluePrimary }}
        {...props}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          fontSize={textSize}
        >{`${Math.round(value)}${isPercentage ? "%" : ""}`}</Typography>
      </Box>
    </Box>
  );
}
